export const getPaymentProviders = async () => {
    const apiUrl = `${process.env.REACT_APP_API_URL}/payment-providers`;

    try {
        const response = await fetch(apiUrl, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (response.status === 404) {
            return [];
        }

        if (!response.ok) {
            const errorText = await response.text();
            console.error("Error response text:", errorText);
            throw new Error("Network response was not ok");
        }
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/json")) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            const errorText = await response.text();
            console.error("Error: Expected JSON but received:", errorText);
            throw new Error("Received non-JSON response");
        }
    } catch (error) {
        throw error;
    }
};
